import { ConfigurationsByDevice } from '../models';
import { DeepPartial } from '../utils';
import { DEFAULT_DESKTOP_EMPATHY_X_CONFIG as desktop } from './desktop';
import { DEFAULT_EMPATHY_X_CONFIG as mobile } from './mobile';

export const DEFAULT_DEVICES_CONFIGURATION: DeepPartial<ConfigurationsByDevice> = {
  mobile,
  desktop
};
